import { skyCMP } from '../../utils/sky-cmp';
import { insertAfter, createDomElement } from '../../utils/dom-utils';
import { onLmpTabChange } from '../../utils/aem-utils';
import { removeFromArray } from '../../utils/array-utils';
import { hasInlineCardAfterSecondParagraph, hasInlineCardBetweenFirstParagraphs } from './helpers';

const HOOK_ARTICLES_PARAGRAPHS = ".j-article-section > p";
const HOOK_ARTICLES_CHILDREN = ".j-article-section > p, .j-article-section > a.j-inline-card";
const OUTBRAIN_CLASSNAME = 'OUTBRAIN';

let initializedMain = false;
let initializedInline = false;

/**
 * Outbrain widget after first article paragraph
 */
const initOutbrainInnerText = (node, addScript) => {

  const $articlesChildren = document.querySelectorAll(HOOK_ARTICLES_CHILDREN);
  const $articlesParagraphs = document.querySelectorAll(HOOK_ARTICLES_PARAGRAPHS);

  // With no empty paragraphs
  const $articlesChildrenNoEmpty = Array.from($articlesChildren).filter(
    (item) => item.textContent.trim().length > 0
  );
  const $articlesParagraphsFiltered = Array.from($articlesParagraphs).filter(
    (item) => item.textContent.trim().length > 0
  );

  // In case the article has less than 2 paragraphs
  if (!$articlesParagraphsFiltered[1]) {
    return;
  }

  if (hasInlineCardBetweenFirstParagraphs($articlesChildrenNoEmpty)) {
    removeFromArray($articlesChildrenNoEmpty, 1); // remove first inline-card from the array
  }

  // create the element for inject in the page
  const divElement = createDomElement('div', {
    'data-src': node.dataset.url,
    'data-widget-id': node.dataset.widgetId,
    'data-intcmp': node.dataset.intcmp,
  });
  divElement.classList.add(OUTBRAIN_CLASSNAME);

  if (addScript) {
    const scriptElement = createDomElement('script', {
      async: true,
      src: node.dataset.srcjs,
    });
    if (hasInlineCardAfterSecondParagraph($articlesChildrenNoEmpty)) {
      insertAfter($articlesChildrenNoEmpty[2], scriptElement);
    } else {
      insertAfter($articlesChildrenNoEmpty[1], scriptElement);
    }
  }

  if (hasInlineCardAfterSecondParagraph($articlesChildrenNoEmpty)) {
    insertAfter($articlesChildrenNoEmpty[2], divElement);
  } else {
    insertAfter($articlesChildrenNoEmpty[1], divElement);
  }
};

/**
 * Outbrain widget in article body
 */
const initOutbrainMain = (node) => {
  const scriptElement = createDomElement('script', {
    async: true,
    src: node.dataset.srcjs,
  });
  insertAfter(node, scriptElement);
};

/**
 * Outbrain widget initialization base on CMP consent
 */
export const initOutbrainScript = ({ main, inText }) => {
  skyCMP.onLoadOrInteraction(() => {
    if (main && !initializedMain) {
      initOutbrainMain(main);
      initializedMain = true;
    }
    if (inText && !initializedInline) {
      initOutbrainInnerText(inText, !main);
      initializedInline = true;
    }
    onLmpTabChange(() => {
      OBR?.extern?.reloadWidget();
    });
  });
};
